import { Link } from "react-router-dom";
import Button from "@/components/base/Button";
import Reveal from "@/components/base/Reveal";
import { useUi } from "@/context/UiContext";

const KEYWORDS = ["看見自己", "開始行動", "建立系統", "持續成長"];

export default function Hero() {
  const { openQuiz } = useUi();

  return (
    <section className="relative overflow-hidden">
      <div className="mx-auto max-w-container-wide px-4 md:px-6 pt-12 md:pt-16 lg:pt-20 pb-12 md:pb-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          {/* Left text */}
          <div className="lg:col-span-7">
            <Reveal>
              <p className="text-xs font-semibold uppercase tracking-[0.24em] text-gold">
                Happiness Talent System
              </p>
              <h1 className="mt-5 text-[2rem] md:text-[2.75rem] font-bold leading-[1.3] text-ink">
                從知道，到做到；
                <br />
                從做到，到持續做到。
              </h1>
              <p className="mt-6 text-base md:text-lg leading-[1.8] text-ink-soft reading-width">
                你不是不夠努力，也不一定是缺少更多方法。很多時候，真正卡住我們的，
                是沒有看清楚自己的信念、行動方式與人生方向。幸福人才養成系統陪你從
                看見卡點開始，把想法轉成行動，再一步一步建立能持續運轉的成長方式。
              </p>

              <div className="mt-8 flex flex-col sm:flex-row gap-4">
                <Button onClick={openQuiz} size="lg" icon="ri-arrow-right-line">
                  30 秒找出我的行動卡點
                </Button>
                <Button to="/happiness-talent-system" size="lg" variant="outline">
                  了解幸福人才養成系統
                </Button>
              </div>

              <Link
                to="/corporate-training"
                className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-primary cursor-pointer transition-colors duration-200 hover:text-gold"
              >
                企業／團隊培訓
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
            </Reveal>
          </div>

          {/* Right photo placeholder */}
          <div className="lg:col-span-5">
            <Reveal delay={120}>
              <div className="relative rounded-card overflow-hidden bg-primary-dark aspect-[4/5] max-w-sm lg:max-w-none mx-auto lg:mx-0 flex flex-col items-center justify-center">
                <div className="w-16 h-16 flex items-center justify-center">
                  <i
                    className="ri-user-3-line text-5xl text-white/30"
                    aria-hidden="true"
                  ></i>
                </div>
                <p className="mt-4 text-sm font-semibold text-white/70">講師照片｜待補</p>
                <p className="mt-1 text-xs text-white/40">許文彰</p>
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gold"></div>
              </div>
            </Reveal>
          </div>
        </div>

        {/* Keyword strip */}
        <Reveal delay={200}>
          <div className="mt-12 pt-8 border-t border-line flex flex-wrap items-center gap-x-6 gap-y-2">
            {KEYWORDS.map((k, i) => (
              <span key={k} className="flex items-center gap-6 text-sm font-medium text-ink-soft">
                {i > 0 && (
                  <span className="text-gold" aria-hidden="true">
                    ｜
                  </span>
                )}
                {k}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}